import { render } from "./Unit3-2.vue?vue&type=template&id=47573c0d&scoped=true"
import script from "./Unit3-2.vue?vue&type=script&lang=js"
export * from "./Unit3-2.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit3-2.css?vue&type=style&index=1&id=47573c0d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47573c0d"]])

export default __exports__